module.exports = __webpack_public_path__ + "static/img/img3.1ae56d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/public/img3.png
// module id = 5F/G
// module chunks = 3